/**
 * RESPONSIBILITY: draw the statement of faith.
 *
 * A numbered run of articles rather than cards: this is a document, and somebody reading
 * it is reading it in order rather than choosing one.
 *
 * It sits on the About page itself, under the mission and vision — it used to be a page of
 * its own with a band here linking to it. The menu's "What we believe" still points at
 * #about/believe, which now scrolls to this band: `data-anchor` is the name it answers to.
 */
import { idOf } from '@framework/core';
import { Html } from '@framework/react';
import type { AboutFaithSection } from '@app/sections';

export function AboutFaith({ c }: { c: AboutFaithSection }) {
  const articles = c.articles ?? [];

  return (
    <section className="band about-faith" id="believe" data-anchor="believe">
      <div className="wrap">
        <div className="band-head">
          <div>
            {c.eyebrow && <span className="about-kicker">{c.eyebrow}</span>}
            <h2>{c.heading}</h2>
          </div>
        </div>
        {c.intro && <p className="lede">{c.intro}</p>}
        <ol className="creed">
          {articles.map((a, i) => (
            <li key={idOf(a) || i}>
              <h3>{a.title}</h3>
              {a.bodyHtml && <Html className="md-body">{a.bodyHtml}</Html>}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
